export const NUMEROLOGY_PAGE_HEADLINES = {
  en: "Free Numerology Calculator",
  hi: "मुफ़्त अंक ज्योतिष कैलकुलेटर",
} as const;
